import { render } from "./swipes.vue?vue&type=template&id=0ba33378&scoped=true"
import script from "./swipes.vue?vue&type=script&lang=js"
export * from "./swipes.vue?vue&type=script&lang=js"

import "./swipes.vue?vue&type=style&index=0&id=0ba33378&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ba33378"

export default script